import axios, { clientContext } from './config'

// AUTH
const apiSubscribe = {
  getSubscriptionQuote (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/subscription_quote/`, data)
  },
  getPlans (promoOverride, forHomepage = false) {
    const queryParams = []
    if (promoOverride) {
      queryParams.push('promo_code=' + promoOverride)
    }
    if (forHomepage) {
      queryParams.push('for_homepage=true')
    }
    const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
    return axios.get('/api/plans/' + queryString)
  },
  subscribeClient (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/subscribe_client/`, data)
  },
  getReferralCampaign () {
    return axios.get('/api/referralcampaigns/')
  },
  getQuote ({ planId, codes }) {
    let queryParams = ''
    if (codes) {
      queryParams += '?promo_codes=' + codes
    }
    return axios.get('/api/plans/' + planId + '/quote/' + queryParams)
  },
  changePlan ({ planId, data }) {
    return axios.post('/api/plans/' + planId + '/subscribe/', data)
  },
  validateReferralCode (code) {
    return axios.get('/api/clients/?referralCode=' + code)
  },
  getCancelReasons () {
    return axios.get('/api/cancelreasons/')
  }
}

export default apiSubscribe
